<style lang="stylus" scoped>
.Breath
	width 100%
	height 100vh

.lung
	width 100vw
	bottom 0
	position absolute
	z-index 1

.Config
	z-index 2
	margin 0 auto

	@media (max-width: 500px)
		width 100%
		left 0

.current
	position absolute
	bottom 10%
	width 100%
	text-align center

	color rgba(128, 128, 128, 0.5)
	z-index 3
	*
		display inline-block
	&>div
		margin-right 20px
		&>label
			margin-right 4px

.inhale,.exhale,.hold
	color rgba(128, 128, 128, 0.8)
	text-shadow 0 0 16px #4a4
	position absolute
	width 100vw
	top 44vh
	opacity 0
	font-size 4rem
	z-index 3
	text-align center

.footer
	text-align center
	a>span
		vertical-align top
		padding-top 6px
		display inline-block

</style>


<template lang="pug">
div.Breath( v-bind:style="{backgroundColor: colorBackground.hex}" v-on:click="stop")
	.lung(
		ref="lung"
		v-bind:style="{backgroundColor: colorBreath.hex}"
		v-show = "!configVisible"
		)
	.inhale(ref="inhale" v-show = "!configVisible") inhale
	.exhale(ref="exhale" v-show = "!configVisible") exhale
	.hold(ref="hold" v-show = "!configVisible") hold
	Config( v-show="configVisible"
			:ColorBackground = "colorBackground"
			:ColorBreath = "colorBreath"
			:Duration = "duration"
			v-on:changeColorBreath="changeColorBreath"
			v-on:changeColorBackground="changeColorBackground"
			v-on:start="start"
			)
	.current(v-show = "!configVisible")
		div
			label inhale:
			.value {{ Math.round(current.inhale/10)/100 }}
		div
			label hold 1:
			.value {{ Math.round(current.hold1/10)/100 }}
		div
			label exhale:
			.value {{ Math.round(current.exhale/10)/100 }}
		div
			label hold 2:
			.value {{ Math.round(current.hold2/10)/100 }}
	div.footer(v-show="configVisible")
		a(href="https://twitter.com/breath_fi") 
			img(src="/twitter_icon.png")
			span @breath_fi
</template>


<script>
import Config from "./Config.vue";
import animate from '../animate';
import NoSleep from 'nosleep.js';

export default {
	props: [],
	components: {
		Config
	},
	mounted: function () {
	},
	data: function () {
		return{
			configVisible : true,
			colorBreath: { hex: '#194d33' },
			colorBackground: { hex: "#f0e8e0" },
			duration:{
					startInhale: 5000,
					startHold1: 1000,
					startExhale: 5000,
					startHold2: 1000,
					endInhale: 7000,
					endHold1: 2000,
					endExhale: 7000,
					endHold2: 2000,
					length: 5 * 60 * 1000,
					stopWhenDone: true
				},
			current:{
				inhale: 0,
				hold1: 0,
				exhale: 0,
				hold2: 0
			},
			step:{
				inhale: 0.1,
				hold1: 0.1,
				exhale: 0.1,
				hold2: 0.1
			},
			numSteps : 10,

			breath: null,
			inhale: null,
			exhale: null,
			
			startTotal : 1,
			endTotal : 1,
			noSleep : new NoSleep()
		}
	},
	methods: {
		changeColorBreath(msg, evt){
			console.log(msg, evt)
			this.colorBreath = msg
		},
		changeColorBackground(msg, evt){
			console.log(msg.hex)
			this.colorBackground = msg
		},
		animateNext(){
			this.breath = animate.breath(this.$refs.lung, this.current.inhale, this.current.hold1, this.current.exhale, this.current.hold2, this.next)
			this.inhale = animate.showInhale(this.$refs.inhale, this.current.inhale, this.current.hold1, this.current.exhale, this.current.hold2, this.next)
			this.exhale = animate.showExhale(this.$refs.exhale, this.current.inhale, this.current.hold1, this.current.exhale, this.current.hold2, this.next)
			if(this.current.hold1 > 500 || this.current.hold2 > 500)
				this.hold   = animate.showHold  (this.$refs.hold,   this.current.inhale, this.current.hold1, this.current.exhale, this.current.hold2, this.next)

			this.breath.finished.then(this.next)
		},
	    start() {
			this.current.inhale   = this.duration.startInhale
			this.current.hold1    = this.duration.startHold1
			this.current.exhale   = this.duration.startExhale
			this.current.hold2    = this.duration.startHold2
			this.startTotal  = this.duration.startInhale + this.duration.startHold1 + this.duration.startExhale + this.duration.startHold2
			this.endTotal    = this.duration.endInhale + this.duration.endHold1 + this.duration.endExhale + this.duration.endHold2
			//this.numSteps    = 2 * this.duration.length / (this.endTotal - this.startTotal)
			this.numSteps    = 2 * this.duration.length / (this.endTotal + this.startTotal)

			this.step.inhale = (this.duration.endInhale - this.duration.startInhale) / this.numSteps
			this.step.hold1  = (this.duration.endHold1  - this.duration.startHold1)  / this.numSteps
			this.step.exhale = (this.duration.endExhale - this.duration.startExhale) / this.numSteps
			this.step.hold2  = (this.duration.endHold2  - this.duration.startHold2)  / this.numSteps

			this.animateNext()

			this.configVisible = false
			this.noSleep.enable()
		},
		next(){
			// todo: what happens when end time is reached
			let cIncrement = this.current.inhale < this.duration.endInhale

			if(cIncrement)
			{
				this.current.inhale += this.step.inhale
				this.current.hold1  += this.step.hold1
				this.current.exhale += this.step.exhale
				this.current.hold2  += this.step.hold2

				this.animateNext()
			}
			else if(this.duration.stopWhenDone)
			{
				this.stop()
			}

			if(!cIncrement && !this.duration.stopWhenDone)
			{
				this.animateNext()
			}
		},
		stop(){
			if(this.breath && this.breath.began)
			{
				this.breath.pause()
				this.configVisible = true
				this.noSleep.disable()
			}
		}
	}
}


//done: screen keep on
//done: stop on done check box
//done: proper centering
//done: mobile support
//done: validation
//done: fix inhale/exhale animation
//done: show inhale/exhale text
//done: show hold text
//done: contact/us: twitter

//todo: save options on device

//todo: contact/us: facebook
//todo: usage notes/help/faq

//todo: google tracking

//todo: templates


</script>

